import React from 'react';
import ResetPasswordView from "../views/ResetPasswordView";

function ResetPasswordPresenter() {
  return (
    <ResetPasswordView/>
  );
}

export default ResetPasswordPresenter;
